import { grey200 } from "styles";

export const styles = {
  preview: {
    display: { xs: "none", md: "flex" },
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "center",
    width: "55%",

    backgroundColor: grey200,
    p: "24px 40px",
    "@media (max-width: 1100px)": {
      overflowY: "auto",
    },
  },
  previewHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    mb: 2,
  },
};
